import React, { useState, useEffect } from "react";
import styled from "styled-components";
import RenderEvent from "./Event";

const TimelineWrapper = styled.div`
	background-color: #f7f7f7;
	padding: 0 32px 0 32px;
	min-height: 500px;
	.timelineHeader {
		border-bottom: 1px solid #dddddd;
		text-align: center;
	}
	border: 1px solid #eee;
	border-radius: 4px;
`;

const EventContainer = styled.div`
	position: relative;
	width: 94%;
	height: 300px;
	margin-top: 24px;
`;

function getEventsWithPlacements(events) {
	if (events.length > 0) {
		events.sort((a, b) => a.date.getTime() - b.date.getTime());

		const minDate = events[0].date.getTime();
		const max = events[events.length - 1].date.getTime() - minDate;

		return events.map(event => {
			const pos = event.date.getTime() - minDate;
			const placement = pos / max;

			return { ...event, placement: placement };
		});
	}
	return [];
}

function getEventGroups(eventsWithPlacements, groupBy = 2678400000) {
	const eventGroups = {};

	eventsWithPlacements.forEach((event, eventIndex) => {
		if (!event.group) {
			eventGroups[event.id] = [];
			for (let i = 0; i < eventsWithPlacements.length; i++) {
				const diff = Math.abs(
					eventsWithPlacements[i].date.getTime() -
						event.date.getTime()
				);
				if (!eventsWithPlacements[i].group) {
					if (diff < groupBy) {
						eventGroups[event.id].push(eventsWithPlacements[i]);
						eventsWithPlacements[i].group = event.id;
					} else if (eventIndex < i) {
						break;
					}
				}
			}
		}
	});
	return eventGroups;
}

function getUpcomingEventIndex(eventGroups) {
	let nextEventIndex = -1;
	const today = new Date(new Date(Date.now()).toDateString()).getTime(); //get the beginning of today
	const eventGroupKeys = Object.keys(eventGroups);
	for (let i = 0; i < eventGroupKeys.length; i++) {
		eventGroups[eventGroupKeys[i]].forEach(event => {
			if (event.date.getTime() >= today) {
				nextEventIndex = i;
			}
		});
		if (nextEventIndex > -1) {
			break;
		}
	}

	return nextEventIndex;
}

const getLargestGroupSize = eventGroups => {
	let largestGroupSize = 0;

	Object.keys(eventGroups).forEach(key => {
		largestGroupSize = Math.max(largestGroupSize, eventGroups[key].length);
	});
	return largestGroupSize;
};

const Timeline = ({ events, heading, iconMap, groupBy }) => {
	const eventsWithDates = events.map(event => ({
		...event,
		date: new Date(event.date),
	}));

	const eventsWithPlacements = getEventsWithPlacements(eventsWithDates);

	const eventGroups = getEventGroups(eventsWithPlacements, groupBy);
	const largestGroupSize = getLargestGroupSize(eventGroups);
	const nextEventIndex = getUpcomingEventIndex(eventGroups);

	const [visibleIndex, setVisibleIndex] = useState(Infinity);

	useEffect(() => {
		setVisibleIndex(
			nextEventIndex > -1
				? nextEventIndex
				: eventsWithPlacements.length - 1
		);
	}, [groupBy]);

	return (
		<>
			{events.length > 0 ? (
				<TimelineWrapper>
					<div className="timelineHeader">{heading}</div>
					<EventContainer>
						<svg
							width="100%"
							height="40px"
							style={{ position: "absolute", top: 103, left: 15 }}
							fill="#6a727d"
						>
							<rect x="0" y="0" height="3" rx="2" width="100%" />
						</svg>
						{Object.keys(eventGroups).map((groupKey, i) => (
							<RenderEvent
								isVisible={visibleIndex === i}
								flipEventInfo={
									eventGroups[groupKey][0].placement > 0.5
								}
								eventGroup={eventGroups[groupKey]}
								largestGroupSize={largestGroupSize}
								key={groupKey}
								handleUserSelect={() => setVisibleIndex(i)}
								iconMap={iconMap}
								top={"74px"}
							/>
						))}
					</EventContainer>
					<div style={{ width: "40px" }} />
				</TimelineWrapper>
			) : null}
		</>
	);
};

export default Timeline;
